import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { OptionDataValue } from 'echarts/types/src/util/types';
import { EChartsCoreOption, BarSeriesOption, number } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_FUNNEL_FORM_DATA,
    EchartsWaterfallChartProps,
    EchartsWaterfallFormData,
    WaterfallChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';

// basic  
  
export default function transformProps(
    chartProps: EchartsWaterfallChartProps,
): WaterfallChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric,
      showLegend
    }: EchartsWaterfallFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_FUNNEL_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel) : [getColumnLabel(groupby)];
    const keys = data.map(datum =>
      extractGroupbyLabel({ datum, groupby: groupbyLabels, coltypeMapping: {} }),
    );
    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;
  
    const seriesData: DataRecordValue[] = data.map(datum => datum[metricLabel]);
    const seriesTotal = seriesData.reduce(
      (accumulator, currentValue) =>
        number.numericToNumber(accumulator) + number.numericToNumber(currentValue),
      0
    );
    const placeholderSeriesData: OptionDataValue[] = [0];
    let rollingSum = 0;
    seriesData.forEach(value => {
      rollingSum += number.numericToNumber(value);
      placeholderSeriesData.push(number.numericToNumber(seriesTotal) - rollingSum)
    });
    seriesData.unshift(seriesTotal as DataRecordValue);
    keys.unshift('Total');


    const series: BarSeriesOption[] = [
      {
        name: 'Placeholder',
        type: 'bar',
        stack: 'Total',
        itemStyle: {
          borderColor: 'transparent',
          color: 'transparent'
        },
        emphasis: {
          itemStyle: {
            borderColor: 'transparent',
            color: 'transparent'
          }
        },
        data: placeholderSeriesData
      },
      {
        name: metricLabel,
        type: 'bar',
        stack: 'Total',
        label: {
          show: true,
          position: 'inside'
        },
        // @ts-ignore
        data: seriesData,
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      tooltip: {},
      legend: {
        show: showLegend
      },
      xAxis: {
        type: 'category',
        splitLine: { show: false },
        data: keys
      },
      yAxis: {
        type: 'value'
      },
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  